import { Component, OnInit } from '@angular/core';
import {BooKingservice} from "../../booking/booking.service";
import {Router} from "@angular/router";
import {FoEventsService} from "../../event/foevents.service";

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {
  currenteventUrl:any;
  order :any;
  trans:any;
  constructor(private bookingservice:BooKingservice,private router: Router, private eventservice: FoEventsService) {

  }

  ngOnInit() {
    this.currenteventUrl =  this.bookingservice.retrieve('currenteventUrl');
    this.order = this.bookingservice.retrieve('inscriptionOrder');
    this.trans = this.bookingservice.retrieve('trans');
  }

  Retour() {
    this.router.navigate(['/']);
  }

  validateAndGenerateOrder(){
    let data = {'trans':this.trans ,'order_id':this.order.id}
    this.eventservice.ValidateAndGenerateOrder(data).then(res =>{

    })

  }



}
